import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscriber, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NbAuthService } from '@nebular/auth';
import { NbThemeService } from '@nebular/theme';
import { config } from '../../../config';

@Injectable({
  providedIn: 'root'
})
export class AdminApiService {
  public baseUrl = config.serverUrl;
  private preBaseUrl = config.preServerUrl;
  constructor(private httpClient : HttpClient,
    public authService : NbAuthService,
    public themeService : NbThemeService) { }


/** Admin Request*/
sendOtp(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Application/get_otp`);
  }catch(error) {
      this.handleError("sendOtp : "+JSON.stringify(error));
  }
}
updateOtp(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Application/update_otp`);
  }catch(error) {
      this.handleError("updateOtp : "+JSON.stringify(error));
  }
}
getApplication(tab_type,year){
    try{
        return this.httpClient.get(`${this.baseUrl}/admin_api/Application?tab=`+tab_type+`&year=`+year);
    }catch(error) {
        this.handleError("getApplication : "+JSON.stringify(error));
    }
}

getApplicationCourseWise(tab_type,year,course_id,page,collegeId){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Application/getApplicationCourseWise?tab=`+tab_type+`&year=`+year+`&course_id=`+course_id+`&page=`+page+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("getApplication : "+JSON.stringify(error));
  }
}

getUGPGApplications(tab_type,year){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Application/getUGPGApplications?tab=`+tab_type+`&year=`+year);
  }catch(error) {
      this.handleError("getApplication : "+JSON.stringify(error));
  }
}

getCompletedApplication(tab_type){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Application/getCompletedApplication?tab=`+tab_type);
  }catch(error) {
      this.handleError("getCompletedApplication : "+JSON.stringify(error));
  }
}

getUntickedApplication(unticked){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Application/unticked_applications?tab=`+unticked);
  }catch(error) {
      this.handleError("getUntickedApplication : "+JSON.stringify(error));
  }
}

getactutialGiven(tab){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Application/acturialgiven_applications?tab=`+tab);
  }catch(error) {
      this.handleError("getactutialGiven : "+JSON.stringify(error));
  }
}

getIccrApplication(tab){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/iccr?tab=`+tab);
  }catch(error) {
      this.handleError("getIccrApplication : "+JSON.stringify(error));
  }
}

getApplicationinEligibility(tab_type,academic_year){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility?tab=`+tab_type+`&year=`+academic_year);
  }catch(error) {
      this.handleError("getApplicationinEligibility : "+JSON.stringify(error));
  }
}
getRejectedApplication(pageNum,collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/getRejected?page=`+pageNum+`&collegeId=`+collegeId);
  }catch(error){
    this.handleError("getRejectedApplication : "+JSON.stringify(error));
  }
}

getPreRejectedApplication(pageNum,collegeId){
  try{
    return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/getRejected?page=`+pageNum+`&collegeId=`+collegeId);
  }catch(error){
    this.handleError("getPreRejectedApplication : "+JSON.stringify(error));
  }
}

undoApplicant(id,spec,check){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/undoApplicant`,{
         'spec' : spec,
          'user_id' : id,
          'check': check,
          });
  }catch(error){
    console.log();
  }
}

preundoApplicant(id,spec,check){
  try{
    return this.httpClient.post(`${this.preBaseUrl}/admin_api/Eligibility/undoApplicant`,{
         'spec' : spec,
          'user_id' : id,
          'check': check,
          });
  }catch(error){
    console.log();
  }
}


getApplicationtoCheckEligibility(tab_type,academic_year,pages,collegeId){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/CheckEligibility?tab=`+tab_type+`&year=`+academic_year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("getApplicationinEligibility : "+JSON.stringify(error));
  }
}
getPreApplicationtoCheckEligibility(tab_type,academic_year,pages,collegeId){
  try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/CheckEligibility?tab=`+tab_type+`&year=`+academic_year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("getApplicationinEligibility : "+JSON.stringify(error));
  }
}
getEmailTracker(collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/getEmailTracker?collegeId=${collegeId}`);
  }catch(error) {
      this.handleError("getEmailTracker : "+JSON.stringify(error));
  }
}

getSMSTrackerMonthWise(params){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Dashboard/getSMSTrackerMonthWise`,{
      yearMonth : params,
    });
  } catch(error) {
      this.handleError("getSMSTrackerMonthWise : "+JSON.stringify(error));
  }
}

getSMSActivityMonthWise(params){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/report/getSMSActivityMonthWise`,{
      yearMonth : params,
    });
  }catch(error) {
      this.handleError("getSMSActivityMonthWise : "+JSON.stringify(error));
  }
}

getEmailActivityTrackerMonthWise(params){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Dashboard/getEmailActivityTrackerMonthWise`,{
      yearMonth : params,
    });
  } catch(error) {
      this.handleError("getEmailActivityTrackerMonthWise : "+JSON.stringify(error));
  }
}

getEmailActivityTracker(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Dashboard/getEmailActivityTracker`);
  }catch(error) {
    this.handleError("getEmailActivityTracker : "+JSON.stringify(error));
  }
}

getICCRApplicationinEligibility(status){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/iccr/iccr_elgibility?tab=`+status);
  }catch(error) {
      this.handleError("getICCRApplicationinEligibility : "+JSON.stringify(error));
  }
}

geticcr_allocated_college_data(){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/iccr/iccr_allocated_college_data`);
  }catch(error) {
      this.handleError("geticcr_allocated_college_data : "+JSON.stringify(error));
  }
}

getrequested_unlocked_transcript(pageNum){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/requested_unlocked_transcript?page=`+pageNum);
  }catch(error) {
      this.handleError("getrequested_unlocked_transcript : "+JSON.stringify(error));
  }
}

getPrerequested_unlocked_transcript(pageNum){
  try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/requested_unlocked_transcript?page=`+pageNum);
  }catch(error) {
      this.handleError("getrequested_unlocked_transcript : "+JSON.stringify(error));
  }
}

geticcr_requested_unlocked_transcript(){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/iccr/iccr_requested_unlocked_transcript`);
  }catch(error) {
      this.handleError("geticcr_requested_unlocked_transcript : "+JSON.stringify(error));
  }
}

async getAllUserData(userId,courseId,applicationId,tab){
  try{
    return await this.httpClient.get(`${this.baseUrl}/admin_api/View/view?userId=`+userId+`&courseId=`+courseId+`&applicationId=`+applicationId+`&tab=`+tab).toPromise();
  }catch(error) {
    this.handleError("getAllUserData : "+error);
  }
}
async getAllUserDataPre(userId,courseId,applicationId,tab){
  try{
    return await this.httpClient.get(`${this.preBaseUrl}/admin_api/View/view?userId=`+userId+`&courseId=`+courseId+`&applicationId=`+applicationId+`&tab=`+tab).toPromise();
  }catch(error) {
    this.handleError("getAllUserData : "+error);
  }
}
async getAllTranscriptData(userId){
    try{
      return await this.httpClient.get(`${this.baseUrl}/admin_api/Errata?userId=`+userId).toPromise();
    }catch(error) {
      this.handleError("getAllTranscriptData : "+error);
    }
  }
  async getAllTranscriptDataPre(userId){
    try{
      return await this.httpClient.get(`${this.preBaseUrl}/admin_api/Errata?userId=`+userId).toPromise();
    }catch(error) {
      this.handleError("getAllTranscriptData : "+error);
    }
  }
  async getAllTranscriptDataOfICCR(userId){
    try{
      return await this.httpClient.get(`${this.baseUrl}/admin_api/iccr/transcript_data?userId=`+userId).toPromise();
    }catch(error) {
      this.handleError("getAllTranscriptDataOfICCR : "+error);
    }
  }
  async getAllTranscriptDataOfICCRPre(userId){
    try{
      return await this.httpClient.get(`${this.preBaseUrl}/admin_api/iccr/transcript_data?userId=`+userId).toPromise();
    }catch(error) {
      this.handleError("getAllTranscriptDataOfICCR : "+error);
    }
  }
  updateErrataTranscript(errataTranscript,comment){
    try{
        return this.httpClient.post(`${this.baseUrl}/admin_api/Errata/updateErrataTranscript`,{"errataTranscript":errataTranscript,"comment":comment});
    }catch(error) {
        this.handleError("updateErrataTranscript : "+JSON.stringify(error));
    }
  }

  preupdateErrataTranscript(errataTranscript,comment){
    try{
        return this.httpClient.post(`${this.preBaseUrl}/admin_api/Errata/updateErrataTranscript`,{"errataTranscript":errataTranscript,"comment":comment});
    }catch(error) {
        this.handleError("updateErrataTranscript : "+JSON.stringify(error));
    }
  }

  updateErrataTranscriptofICCR(errataTranscriptofICCR){
    try{
        return this.httpClient.post(`${this.baseUrl}/admin_api/iccr/updateErrataTranscript`,{"errataTranscriptofICCR":errataTranscriptofICCR});
    }catch(error) {
        this.handleError("updateErrataTranscriptofICCR : "+JSON.stringify(error));
    }
  }

  preupdateErrataTranscriptofICCR(errataTranscriptofICCR){
    try{
        return this.httpClient.post(`${this.preBaseUrl}/admin_api/iccr/updateErrataTranscript`,{"errataTranscriptofICCR":errataTranscriptofICCR});
    }catch(error) {
        this.handleError("updateErrataTranscriptofICCR : "+JSON.stringify(error));
    }
  }

rejectApplication(userId,courseId){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/rejectApplication`,{"user_id":userId,"course_id":courseId});
  }catch(error) {
      this.handleError("rejectApplication : "+JSON.stringify(error));
  }
}

preRejectApplication(userId,courseId){
  try{
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/Eligibility/rejectApplication`,{"user_id":userId,"course_id":courseId});
  }catch(error) {
      this.handleError("rejectApplication : "+JSON.stringify(error));
  }
}

acceptApplication(userId,courseId,eligib_number){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/acceptApplication`,{"user_id":userId,"course_id":courseId,"eligib_number":eligib_number});
  }catch(error) {
      this.handleError("acceptApplication : "+JSON.stringify(error));
  }
}

acceptApplicationICCR(id,userId,courseId,eligib_number){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/iccr/acceptApplicationICCR`,{"id":id,"user_id":userId,"course_id":courseId,"eligib_number":eligib_number});
  }catch(error) {
      this.handleError("acceptApplicationICCR : "+JSON.stringify(error));
  }
}

rejectApplicationICCR(userId,courseId){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/iccr/rejectApplicationICCR`,{"user_id":userId,"course_id":courseId});
  }catch(error) {
      this.handleError("rejectApplicationICCR : "+JSON.stringify(error));
  }
}

async getAllStudentData(userId){
  try{
      return await this.httpClient.get(`${this.baseUrl}/admin_api/View/studentview?userId=`+userId).toPromise();
  }catch(error) {
  this.handleError("getAllUserData : "+error);
  }
}
async getAllStudentDataPre(userId){
  try{
      return await this.httpClient.get(`${this.preBaseUrl}/admin_api/View/studentview?userId=`+userId).toPromise();
  }catch(error) {
  this.handleError("getAllUserData : "+error);
  }
}
async getAllIccrStudentData(userId,courseId,applicationId,tab){
  try{
    return await this.httpClient.get(`${this.baseUrl}/admin_api/iccr/iccrview?userId=`+userId+`&courseId=`+courseId+`&applicationId=`+applicationId+`&tab=`+tab).toPromise();
  }catch(error) {
    this.handleError("getAllUserData : "+error);
  }
}
async getAllIccrStudentDataPre(userId,courseId,applicationId,tab){
  try{
    return await this.httpClient.get(`${this.preBaseUrl}/admin_api/iccr/iccrview?userId=`+userId+`&courseId=`+courseId+`&applicationId=`+applicationId+`&tab=`+tab).toPromise();
  }catch(error) {
    this.handleError("getAllUserData : "+error);
  }
}
getallstudents(){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/students`);
  }catch(error) {
      this.handleError("getallstudents : "+JSON.stringify(error));
    }
}

getallstudentstypewise(stu_type,year,pages,collegeId){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/students?stu_type=`+stu_type+`&year=`+year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("getallstudents : "+JSON.stringify(error));
    }
}

getallstudentstypewisePre(stu_type,year,pages,collegeId){
  try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/students?stu_type=`+stu_type+`&year=`+year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("getallstudents : "+JSON.stringify(error));
    }
}

downloadFiles(pdf):Observable<Blob>{
  try{
  let headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/download?pdf=`+pdf, { headers: headers, responseType: 'blob'}).pipe(map(
      (res) => {
          return new Blob([res], { type: 'application/pdf' });
      }));
  }catch(error) {
    this.handleError("unable to get Files : "+JSON.stringify(error));
  }
}

preDownloadFiles(pdf):Observable<Blob>{
  try{
  let headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/download?pdf=`+pdf, { headers: headers, responseType: 'blob'}).pipe(map(
      (res) => {
          return new Blob([res], { type: 'application/pdf' });
      }));
  }catch(error) {
    this.handleError("unable to get Files : "+JSON.stringify(error));
  }
}

imageDownload(url,filename){
  this.httpClient.get(url, { responseType: 'blob' }).subscribe((blob) => {
    const link = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(objectUrl); // Free up memory
  });
}


//foregin office
downloadDocument(location,file_name):Observable<Blob>{
  try{
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/download_document?file_name=`+file_name+`&location=`+location, { headers: headers, responseType: 'blob'}).pipe(map(
          (res) => {
              return new Blob([res], { type: 'application/pdf' });
          }));
  }catch(error) {
    this.handleError("unable to download_document  : "+JSON.stringify(error));
  }
}

sendEmailToEmbassy(user_id,course_id,application_id,email,countryName){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/sendEmailToEmbassy`,{
          'user_id': user_id ,
          'course_id' : course_id,
          'id' : application_id,
          'email' : email,
          'Country_name' : countryName
      });

  }catch(error) {
      this.handleError("sendEmailToEmbassy : "+JSON.stringify(error));
  }
}

getApplicationinForeignOffice(tab_type,year,page,collegeId){
  try{
      if(tab_type == "new"){
          return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice?tab=`+tab_type+"&year="+year+"&page="+page+"&collegeId="+collegeId);
      }else if(tab_type == "seat_allocation"){
        return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/seat_allocation?tab=`+tab_type+"&year="+year+"&page="+page+"&collegeId="+collegeId);
      }else if(tab_type == "third_payment"){
          return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/third_payment_details?tab=`+tab_type+"&year="+year);
      }else if(tab_type == "seat_alloted_student"){
        var tab = 'accept';
        return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/seat_alloted?tab=`+tab+"&year="+year+"&page="+page+"&collegeId="+collegeId);
      }else if(tab_type == "failed_student"){
        var tab = 'reject';
        return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/seat_alloted?tab=`+tab+"&year="+year+"&page="+page+'&collegeId='+collegeId);
      }

  }catch(error) {
      this.handleError("getApplicationinforeignoffice : "+JSON.stringify(error));
  }
}


sendEmailFromForeignOffice(tab_type,user_id,course_id,application_id){
  try{
      if(tab_type == "student"){
          return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/sendEmailTostudent`,{
              'user_id': user_id ,
              'course_id' : course_id,
              'id' : application_id
          });
      }else if(tab_type == "guardian"){
          return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/sendEmailToguardian`,{
              'user_id': user_id ,
              'course_id' : course_id,
              'id' : application_id
          });
      }else if(tab_type == "embassy"){
          return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/sendEmailToEmbassy`,{
              'user_id': user_id ,
              'course_id' : course_id,
              'id' : application_id
          });
      }

  }catch(error) {
      this.handleError("getApplicationinforeignoffice : "+JSON.stringify(error));
  }
}

async reuploadedTranscriptData(userId){
  try{
    return await this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/re_uploaded_student_transcript?userId=`+userId).toPromise();
  }catch(error) {
    this.handleError("reuploadedTranscriptData : "+error);
  }
}

async ICCR_reuploadedTranscriptData(userId){
  try{
    return await this.httpClient.get(`${this.baseUrl}/admin_api/iccr/re_uploaded_iccr_student_transcript?userId=`+userId).toPromise();
  }catch(error) {
    this.handleError("ICCR_reuploadedTranscriptData : "+error);
  }
}

requestToUpload(id){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/request_transcript_upload`,{transcript_id : id});
}catch(error) {
    this.handleError("requestToUpload : "+JSON.stringify(error));
  }
}

transcriptSetDefault(id,email){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/transcript_set_default`,{transcript_id : id,email: email});
}catch(error) {
    this.handleError("transcriptSetDefault : "+JSON.stringify(error));
  }
}

checkeligiblity(data){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/eligibCheck`,{
        data : data,
      });
  }catch(error) {
      this.handleError("checkeligiblity : "+JSON.stringify(error));
    }
}

sendToEligibilityUGPG(data){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/sendToEligibilityUGPG`,{
        data : data,
      });
  }catch(error) {
      this.handleError("checkeligiblity : "+JSON.stringify(error));
    }
}

validDocument(data){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Application/validDocument`,{
        data : data,
      });
  }catch(error) {
      this.handleError("checkeligiblity : "+JSON.stringify(error));
    }
}

checkforeign(data){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/sendEmailPI`,{
        data : data,
      });
  }catch(error) {
      this.handleError("checkforeign : "+JSON.stringify(error));
    }
}

preCheckforeign(data){
  try{
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/Eligibility/sendEmailPI`,{
        data : data,
      });
  }catch(error) {
      this.handleError("preCheckforeign : "+JSON.stringify(error));
    }
}

preview(userId,courseId,id){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Application/preview`,{userId:userId,courseId:courseId,id:id});
  }catch(error) {
    this.handleError("preview : "+JSON.stringify(error));
  }
}

preview_iccr(userId,courseId,id){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/iccr/preview_iccr`,{userId:userId,courseId:courseId,id:id});
  }catch(error) {
    this.handleError("preview_iccr : "+JSON.stringify(error));
  }
}

DownloadFirmPDFICCR(applicationId,userId){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/iccr/downloadletter`,{application_id:applicationId,user_id:userId});
  }catch(error) {
    this.handleError("DownloadFirmPDFICCR : "+JSON.stringify(error));
  }
}

showprovisionalLetterApp(user_id,course_id,application_id){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/conditional_provisional_letter_regenerate`,{user_id:user_id,course_id:course_id,id:application_id});
  }catch(error) {
    this.handleError("showprovisionalLetterApp : "+JSON.stringify(error));
  }
}

preview_data_with_Preferences(userId,courseId,id){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Application/preview_with_pref`,{userId:userId,courseId:courseId,id:id});
  }catch(error) {
    this.handleError("preview_data_with_Preferences : "+JSON.stringify(error));
  }
}

downloadStudentExcel(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/downloadStudentExcel`);
  }catch(error) {
    this.handleError("downloadStudentExcel : "+JSON.stringify(error));
  }
}

showSeatsExcel(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/seats_excel_sheet`);
  }catch(error) {
    this.handleError("showSeatsExcel : "+JSON.stringify(error));
  }
}

ICCRExcel(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/iccr/Excel_ICCR`);
  }catch(error) {
    this.handleError("ICCRExcel : "+JSON.stringify(error));
  }
}

paymentDetailsExcel(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/Excel_allpaymentdetails`);
  }catch(error) {
    this.handleError("paymentDetailsExcel : "+JSON.stringify(error));
  }
}

showThirdPaymentExcel(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/showThirdPaymentExcel`);
  }catch(error) {
    this.handleError("paymentDetailsExcel : "+JSON.stringify(error));
  }
}

showCollegeAllocatedExcel(collegename){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/showCollegeAllocatedExcel`,{"collegename":collegename});
  }catch(error) {
    this.handleError("showCollegeAllocatedExcel : "+JSON.stringify(error));
  }
}

status(status,userId){
  try{
    return this.httpClient.put(`${this.baseUrl}/admin_api/students/status`,{"status":status,"userId": userId});
  }catch(error) {
    this.handleError("status : "+JSON.stringify(error));
  }
}

Check_Eligibility(user_id,college_university,college_name,Subject_first_hsc,Subject_Second_hsc,Subject_Third_hsc,Subject_fourth_hsc,Subject_fifth_hsc,Subject_Six_hsc,specialization,course){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Application/check_eligibility`,{'user_id':user_id,'college_university':college_university,'college_name':college_name,'Subject_first_hsc':Subject_first_hsc,'Subject_Second_hsc':Subject_Second_hsc,'Subject_Third_hsc':Subject_Third_hsc,'Subject_fourth_hsc':Subject_fourth_hsc,'Subject_fifth_hsc':Subject_fifth_hsc,'Subject_Six_hsc':Subject_Six_hsc});
  }catch(error) {
    this.handleError("Check_Eligibility : "+JSON.stringify(error));
  }
}

Check_Eligibility_data(nrp,specialization,course){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Application/findusers`,{data : nrp,specialization:specialization,course_name : course});
  }catch(error) {
    this.handleError("Check_Eligibility_data : "+JSON.stringify(error));
  }
}

getApplicationsByStatus(year,pages, collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/admission-request?year=`+year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
    this.handleError("getApplicationsByStatus : "+JSON.stringify(error));
  }
}

getApplicationAcceptance(year,pages, collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/application-acceptance?year=`+year+`&pages=`+pages + `&collegeId=`+collegeId);
  }catch(error) {
    this.handleError("getApplicationAcceptance : "+JSON.stringify(error));
  }
}

activitytracker(pages, collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/activitytracker?pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
    this.handleError("activitytracker : "+JSON.stringify(error));
  }
}

interested_data(pages){
  try{
    return this.httpClient.get(`${this.baseUrl}/Interested_Contact_List?pages=`+pages);
  }catch(error) {
    this.handleError("interested_data : "+JSON.stringify(error));
  }
}

campaign_data(pages){
  try{
    return this.httpClient.get(`${this.baseUrl}/campaignStudent_List?pages=`+pages);
  }catch(error) {
    this.handleError("campaign_data : "+JSON.stringify(error));
  }
}

firstPaymentChallanData(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/First_Payment_Challan`);
  }catch(error) {
    this.handleError("firstPaymentChallanData : "+JSON.stringify(error));
  }
}

secondPaymentChallanData(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/Second_Payment_Challan`);
  }catch(error) {
    this.handleError("secondPaymentChallanData : "+JSON.stringify(error));
  }
}

collegeAttendedStudents(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/college_attended`);
  }catch(error) {
    this.handleError("collegeAttendedStudents : "+JSON.stringify(error));
  }
}

studentStatisticsPiechart(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/student-statistics-piechart`);
  }catch(error) {
    this.handleError("studentStatisticsPiechart : "+JSON.stringify(error));
  }
}

getRegistrationTracker(collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/getRegistrationTracker?collegeId=${collegeId}`);
  }catch(error) {
      this.handleError("getRegistrationTracker : "+JSON.stringify(error));
  }
}

getRefererLink(collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/report/getRefererLink?collegeId=${collegeId}`);
  }catch(error) {
      this.handleError("getRefererLink : "+JSON.stringify(error));
  }
}

DownloadProvisionalLetter(user_id,id){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/DownloadProvisionalLetter`,{user_id: user_id,id:id});
  }catch(error) {
    this.handleError("DownloadProvisionalLetter : "+JSON.stringify(error));
  }
}

getallColleges(page){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management?page=`+page);
  }catch(error) {
    this.handleError("getallColleges : "+JSON.stringify(error));
  }
}

getAllCourse(collegeId,page){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getAllCourse?collegeId=`+collegeId+"&page="+page);
  }catch(error) {
    this.handleError("getAllCourse : "+JSON.stringify(error));
  }
}

courseStatus(status,id,collegeId){
  try{
    return this.httpClient.put(`${this.baseUrl}/admin_api/institute_management/courseStatus`,{"status":status,"id": id,"collegeId":collegeId});
  }catch(error) {
    this.handleError("courseStatus : "+JSON.stringify(error));
  }
}

college_status(status,id){
  try{
    return this.httpClient.put(`${this.baseUrl}/admin_api/institute_management/college_status`,{"status":status,"id": id});
  }catch(error) {
    this.handleError("college_status : "+JSON.stringify(error));
  }
}

getallAuthDetails(page){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/auth_details?page=`+page);
  }catch(error) {
    this.handleError("getallAuthDetails : "+JSON.stringify(error));
  }
}

getallAuthDetailsSearch(page,value){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/auth_detailsSearch?page=`+page+"&value="+value);
  }catch(error) {
    this.handleError("getallAuthDetails : "+JSON.stringify(error));
  }
}

getallInstituteRequest(page){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/request?page=`+page);
  }catch(error) {
    this.handleError("getallInstituteRequest : "+JSON.stringify(error));
  }
}

getallInstituteRequestSearch(page,value){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/requestSearch?page=`+page+"&value="+value);
  }catch(error) {
    this.handleError("getallInstituteRequestSearch : "+JSON.stringify(error));
  }
}

getInstitute_list(page){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/Institute_list?page=`+page);
  }catch(error) {
    this.handleError("getInstitute_list : "+JSON.stringify(error));
  }
}

getInstitute_listSearch(page,value){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/Institute_listSearch?page=`+page+"&value="+value);
  }catch(error) {
    this.handleError("getInstitute_listSearch : "+JSON.stringify(error));
  }
}

getTotal(tab_type,year,collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Dashboard/total?tab=`+tab_type+`&year=`+year+'&collegeId='+collegeId);
  }catch(error) {
      this.handleError("getTotal : "+JSON.stringify(error));
  }
}

profile_completeness(year,collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Dashboard?year=${year}&collegeId=${collegeId}`);
  }catch(error) {
      this.handleError("profile_completeness : "+JSON.stringify(error));
  }
}

getStudentEducationDetails(user_id){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/getEducationalDetail`,{
          user_id : user_id,
      });
  }catch(error) {
      this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }
}

studentDeallocateCollege(id,userid,collegename){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/deallocateCollege`,{
          user_id : userid,
          application_id : id,
          collegename : collegename,
      });
  }catch(error) {
      this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }
}

studentPreferencesList(user_id,course_id,application_id){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/collegeListView`,{
          applicationId : application_id,
          userId : user_id,
          course_id :course_id
      });
  }catch(error) {
      this.handleError("getStudentPreferencesList : "+JSON.stringify(error));
  }
}

addMoreCollegesList(user_id,course_id,application_id,specialization){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/addAnotherColleges`,{
          applicationId : application_id,
          userid : user_id,
          course_id :course_id,
          specialization : specialization
      });
  }catch(error) {
      this.handleError("getaddMoreCollegesList : "+JSON.stringify(error));
  }
}


downloadAllocationDraftLetter(userid,enrollment,id):Observable<Blob>{
  try{
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/seatAllocateDraftLetter?user_id=`+userid+`&enrollment_no=`+enrollment+`&application_id=`+id, { headers: headers, responseType: 'blob'}).pipe(map(
          (res) => {
              return new Blob([res], { type: 'application/pdf' });
          }));
  }catch(error) {
    this.handleError("unable to download_document  : "+JSON.stringify(error));
  }
}

downloadFirmLetter(userid,file_name):Observable<Blob>{
  try{
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/download_firm_letter?location=`+userid+`&file_name=`+file_name, { headers: headers, responseType: 'blob'}).pipe(map(
          (res) => {
              return new Blob([res], { type: 'application/pdf' });
          }));
  }catch(error) {
    this.handleError("unable to downloadFirmLetter  : "+JSON.stringify(error));
  }
}

checkDownloadedFirmLetter(userid,specialization,id){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/downloadletter?application_id=`+id+`&specialization=`+specialization+`&user_id=`+userid);
  }catch(error) {
    this.handleError("unable to downloadFirmLetter_new  : "+JSON.stringify(error));
  }
}

generateFirmLetter(userid,specialization,id,collegeFees,course_id){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/generateletter?course_fees=`+collegeFees+`&application_id=`+id+`&specialization=`+specialization+`&user_id=`+userid+`&course_fees_id=`+course_id);
  }catch(error) {
    this.handleError("unable to downloadFirmLetter_new  : "+JSON.stringify(error));
  }
}
collegeAllocation(college_name,application_id){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/selectedCollege`,{
          applicationId : application_id,
          selectedCollege: college_name
      });
  } catch(error) {
      this.handleError("collegeAllocation : "+JSON.stringify(error));
  }
}

downloadChallan(location):Observable<Blob>{
  try{
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/download_challan?location=`+location, { headers: headers, responseType: 'blob'}).pipe(map(
          (res) => {
              return new Blob([res], { type: 'application/pdf' });
          }));
  }catch(error) {
    this.handleError("unable to downloadChallan  : "+JSON.stringify(error));
  }
}

getStudenttracking(year,pages,collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Dashboard/tracking_data?year=`+year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("getStudenttracking : "+JSON.stringify(error));
  }
}

getTickets(tab_type){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Dashboard/getTickets?tab=`+tab_type);
  }catch(error) {
      this.handleError("getTickets : "+JSON.stringify(error));
  }
}

  get(url: string): Observable<any> {
    return new Observable((observer: Subscriber<any>) => {
        let objectUrl: string = null;
        this.httpClient
            .get(url, {
                responseType: 'blob'
            })
            .subscribe(m => {
                objectUrl = URL.createObjectURL(m);
                observer.next(objectUrl);
            });

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
                objectUrl = null;
            }
        };
    });
}

savedate(value,Online_test_date,collegeId){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Application/saveDate`,{
          Online_test_date : Online_test_date,
          date_type : value,
          collegeId:collegeId,
      });
  }catch(error) {
      this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }

}

getSavedDates(page,collegeId){
  try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Application/getSavedDates?page=${page}&collegeId=${collegeId}`);
  }catch(error) {
      this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }

}

saveTime(value,Online_test_time){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Application/saveTime`,{
        Online_test_time : Online_test_time,
        dateId : value
      });
  }catch(error) {
      this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }

}

preSaveTime(value,Online_test_time){
  try{
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/Application/saveTime`,{
        Online_test_time : Online_test_time,
        dateId : value
      });
  }catch(error) {
      this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }

}

saveLocation(value,PI_test_location){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Application/saveLocation`,{
        PI_test_location : PI_test_location,
        dateId : value
      });
  }catch(error) {
      this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }
}

preSaveLocation(value,PI_test_location){
  try{
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/Application/saveLocation`,{
        PI_test_location : PI_test_location,
        dateId : value
      });
  }catch(error) {
      this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }
}

enterPIMarks(id,pi_test_marks,course_id){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/savePIMarks`,{
        application_id : id,
        pi_test_marks : pi_test_marks,
        course_id : course_id
    });
  }catch(error) {
      this.handleError("enterPIMarks : "+JSON.stringify(error));
  }
}

totalseats(user_id,course_id,application_id){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/seatsListView`,{
          applicationId : application_id,
          userId : user_id,
          course_id :course_id
      });
  }catch(error) {
      this.handleError("getStudentPreferencesList : "+JSON.stringify(error));
  }
}

saveStudenttype(user_id,value){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/students/saveStudenttype`,{
          userId : user_id,
          value :value,
      });
  }catch(error) {
      this.handleError("getStudentPreferencesList : "+JSON.stringify(error));
  }
}

saveStudenttypepre(user_id,value){
  try{
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/students/saveStudenttype`,{
          userId : user_id,
          value :value,
      });
  }catch(error) {
      this.handleError("getStudentPreferencesList : "+JSON.stringify(error));
  }
}


allocateSeat(user_id,course_id,application_id,category,spec){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/allocateSeat`,{
          applicationId : application_id,
          userId : user_id,
          course_id :course_id,
          value : category,
          spec : spec
      });
  }catch(error) {
      this.handleError("getStudentPreferencesList : "+JSON.stringify(error));
  }
}

failStudent(user_id,course_id,application_id){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/foreignoffice/failStudent`,{
          applicationId : application_id,
          userId : user_id,
          course_id :course_id
      });
  }catch(error) {
      this.handleError("getStudentPreferencesList : "+JSON.stringify(error));
  }
}

getAllCollegeDetail(college_id){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/institute_view?id=`+college_id);
  }catch(error) {
      this.handleError("getAllCollegeDetail : "+JSON.stringify(error));
  }
}

getPaymentDetails(order_no,page,year, collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/paymentDetails/getPaymentDetails?order_no=`+order_no+"&page="+page+"&year="+year+"&collegeId="+collegeId);
  }catch(error) {
      this.handleError("getPaymentDetails : "+JSON.stringify(error));
  }
}
getPaymentDetailsBySearch(order_no,page,value,year, collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/paymentDetails/getPaymentDetailsBySearch?order_no=`+order_no+"&page="+page+"&value="+value+"&year="+year+"&collegeId="+collegeId);
  }catch(error) {
      this.handleError("getPaymentDetailsBySearch : "+JSON.stringify(error));
  }
}

QATPaymentDetails(page,year, collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/paymentDetails/QATPaymentDetails?page=`+page+"&year="+year+"&collegeId="+collegeId);
  }catch(error) {
      this.handleError("QATPaymentDetails : "+JSON.stringify(error));
  }
}
  getStudentDetails(page, academic_year, collegeId, courseId) {
    try {
      return this.httpClient.get(`${this.baseUrl}/admin_api/scholarship/getStudentDetails?pages=` + page + `&year=` + academic_year + `&collegeId=` + collegeId + `&courseId=` + courseId);
  }catch(error) {
      this.handleError("getStudentDetails : "+JSON.stringify(error));
  }
}

saveScholarship(user_id, scholarship1, scholarship2, scholarship3){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/scholarship/saveScholarship`,{
        user_id : user_id,
        scholarship : scholarship1,
        scholarship2 : scholarship2,
        scholarship3 : scholarship3
    });
  }catch(error) {
      this.handleError("saveScholarship : "+JSON.stringify(error));
  }
}

InterestedNumbers(){
  try{
    return this.httpClient.get(`${this.baseUrl}/Interested_Contact_List_Excel`);
  }catch(error) {
    this.handleError("InterestedNumbers : "+JSON.stringify(error));
  }
}

deleteDate(date){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Application/deleteDate?date=`+date);
  }catch(error) {
    this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }
}

getCourseList(collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/Application/getCourseList?collegeId=`+collegeId);
  }catch(error) {
    this.handleError("getStudentEducationDetails : "+JSON.stringify(error));
  }
}

getallstudentsYearwise(year,pages,collegeId) {
  try{
        return this.httpClient.get(`${this.baseUrl}/admin_api/students/getallstudentsYearwise?year=`+year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
        this.handleError("getallstudentsYearwise : "+JSON.stringify(error));
  }
}

getallstudentsYearwisePre(year,pages,collegeId) {
  try{
        return this.httpClient.get(`${this.preBaseUrl}/admin_api/students/getallstudentsYearwise?year=`+year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
        this.handleError("getallstudentsYearwise : "+JSON.stringify(error));
  }
}

eligibApplication(userId,courseId,app_Id,eligib_value){
  try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/eligibApplication`,{"user_id":userId,"course_id":courseId,"app_Id":app_Id,"eligib_value":eligib_value});
  }catch(error) {
      this.handleError("acceptApplication : "+JSON.stringify(error));
  }
}

preEligibApplication(userId,courseId,app_Id,eligib_value){
  try{
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/Eligibility/eligibApplication`,{"user_id":userId,"course_id":courseId,"app_Id":app_Id,"eligib_value":eligib_value});
  }catch(error) {
      this.handleError("acceptApplication : "+JSON.stringify(error));
  }
}

acceptInterviewApplication(userId,courseId,app_Id,acceptedValue){
  try{
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/Eligibility/acceptInterviewApplication`,{"user_id":userId,"course_id":courseId,"app_Id":app_Id,"acceptedValue":acceptedValue});
  }catch(error) {
      this.handleError("acceptApplication : "+JSON.stringify(error));
  }
}

acceptInterviewApplicationPre(userId,courseId,app_Id,acceptedValue,offerLetter?: File){
  try{
      const formData = new FormData();
      formData.append('user_id', String(userId));
      formData.append('course_id', String(courseId));
      formData.append('app_Id', String(app_Id));
      formData.append('acceptedValue', String(acceptedValue));
      if(offerLetter){
        formData.append('offer_letter', offerLetter, offerLetter.name);
      }
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/Eligibility/acceptInterviewApplication`,formData);
  }catch(error) {
      this.handleError("acceptApplication : "+JSON.stringify(error));
  }
}

// Pre-admission application windows (Institute Management > Pre Admission tab)
getPreAdmissionDates(){
  return this.httpClient.get(`${this.preBaseUrl}/admin_api/institute_management/preAdmissionDates`);
}

savePreAdmissionDates(data, id?){
  if(id){
    return this.httpClient.put(`${this.preBaseUrl}/admin_api/institute_management/preAdmissionDates/`+id, data);
  }
  return this.httpClient.post(`${this.preBaseUrl}/admin_api/institute_management/preAdmissionDates`, data);
}

activatePreAdmissionDates(id){
  return this.httpClient.post(`${this.preBaseUrl}/admin_api/institute_management/preAdmissionDates/`+id+`/activate`, {});
}

deletePreAdmissionDates(id){
  return this.httpClient.delete(`${this.preBaseUrl}/admin_api/institute_management/preAdmissionDates/`+id);
}

rejectForInterviewPre(userId,app_Id){
  try{
      return this.httpClient.post(`${this.preBaseUrl}/admin_api/Eligibility/rejectForInterview`,{"user_id":userId,"app_Id":app_Id});
  }catch(error) {
      this.handleError("rejectForInterviewPre : "+JSON.stringify(error));
  }
}
  private handleError(error){
    console.error(error);
   }

   getAcceptedApplication(pageNum,collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/getAccecpted?page=`+pageNum+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("getAcceptedApplication : "+JSON.stringify(error));
    }
   }

   
   getPreAcceptedApplication(pageNum,collegeId){
    try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/getAccecpted?page=`+pageNum+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("getPreAcceptedApplication : "+JSON.stringify(error));
    }
   }

   updateSpecializationDate(courseData){
    try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/updateSpecializationDate`,courseData);
    }catch(error) {
      this.handleError("updateSpecialization : "+JSON.stringify(error));
      }
   }
   sendMail(userId){
    try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/sendMail`,{userId});
    }catch(error) {
      this.handleError("sendMail : "+JSON.stringify(error));
      }
   }
   getUpdateSendMail(userId){
    try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/Eligibility/getUpdateSendMail`,{userId});
    }catch(error) {
      this.handleError("getUpdateSendMail : "+JSON.stringify(error));
      }
   }
   getPaymentDetails1(userId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/paymentDetails/getPaymentDetail1?user_id=`+userId);
    }catch(error) {
        this.handleError("getPaymentDetail1 : "+JSON.stringify(error));
    }
  }
  getRejectedDocument(collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/getRejectedDocument?collegeId=`+collegeId);
    }catch(error){
      this.handleError("getRejectedDocument : "+JSON.stringify(error));
    }
  }
  getChangedDocument(collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/getChangedDocument?collegeId=`+collegeId);
    }catch(error){
      this.handleError("getChangedDocument : "+JSON.stringify(error));
    }
  }

  getApplicationCourseWiseSearch(tab_type,year,course_id,value,page,collegeId){
    try{
        return this.httpClient.get(`${this.baseUrl}/admin_api/Application/getApplicationCourseWiseSearch?tab=`+tab_type+`&year=`+year+`&course_id=`+course_id+`&value=`+value+`&page=`+page+`&collegeId=`+collegeId)
    }catch(error) {
        this.handleError("getApplicationCourseWiseSearch: "+JSON.stringify(error));
    }
  }

  getApplicationinForeignOfficeSearch(tab_type,year,value,page,collegeId){
    try{
        if(tab_type == "new"){
            return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/foreignofficeSearch?tab=`+tab_type+"&year="+year+"&value="+value+"&page="+page+"&collegeId="+collegeId);
        }else if(tab_type == "seat_allocation"){
          return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/seat_allocationSearch?tab=`+tab_type+"&year="+year+"&value="+value+"&page="+page+'&collegeId='+collegeId);
        }else if(tab_type == "third_payment"){
            return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/third_payment_details?tab=`+tab_type+"&year="+year);
        }else if(tab_type == "seat_alloted_student"){
          var tab = 'accept';
          return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/seat_allotedSearch?tab=`+tab+"&year="+year+"&value="+value+"&page="+page+"&collegeId="+collegeId);
        }else if(tab_type == "failed_student"){
          var tab = 'reject';
          return this.httpClient.get(`${this.baseUrl}/admin_api/foreignoffice/seat_allotedSearch?tab=`+tab+"&year="+year+"&value="+value+"&page="+page+"&collegeId="+collegeId);
        }

    }catch(error) {
        this.handleError("getApplicationinforeignofficeSearch : "+JSON.stringify(error));
    }
  }


  searchgetRejectedApplication(event, pageNum, collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/searchgetRejectedApplication?event=`+event + `&page=`+pageNum+'&collegeId='+collegeId);
    }catch(error){
      this.handleError("searchgetRejectedApplication : "+JSON.stringify(error));
    }
  }

  searchgetPreRejectedApplication(event, pageNum, collegeId){
    try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/searchgetRejectedApplication?event=`+event + `&page=`+pageNum+'&collegeId='+collegeId);
    }catch(error){
      this.handleError("searchgetRejectedApplication : "+JSON.stringify(error));
    }
  }

  searchgetAcceptedApplication(event, pageNum,collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/searchgetAcceptedApplication?event=`+event + `&page=`+pageNum+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("searchgetAcceptedApplication : "+JSON.stringify(error));
    }
  }


  preSearchgetAcceptedApplication(event, pageNum,collegeId){
    try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/searchgetAcceptedApplication?event=`+event + `&page=`+pageNum+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("searchgetAcceptedApplication : "+JSON.stringify(error));
    }
  }

  searchgetstudnetApplication(year,event, pages, collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/students/searchgetstudnetApplication?year=`+year +`&event=`+event + `&pages=`+pages+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("searchgetstudnetApplication : "+JSON.stringify(error));
    }
  }

  searchgetstudnetApplicationPre(year,event, pages, collegeId){
    try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/students/searchgetstudnetApplication?year=`+year +`&event=`+event + `&pages=`+pages+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("searchgetstudnetApplication : "+JSON.stringify(error));
    }
  }
  searchApplicationtoCheckEligibility(tab_type,academic_year,event, pages,collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Eligibility/searchApplicationtoCheckEligibility?tab=`+tab_type+`&year=`+academic_year+`&event=`+event+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("searchApplicationtoCheckEligibility : "+JSON.stringify(error));
  }
  }

  searchPreApplicationtoCheckEligibility(tab_type,academic_year,event, pages,collegeId){
    try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/searchApplicationtoCheckEligibility?tab=`+tab_type+`&year=`+academic_year+`&event=`+event+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("searchApplicationtoCheckEligibility : "+JSON.stringify(error));
  }
  }

  searchgetScholarship(value, pages, year, collegeId, courseId) {
    try {
      return this.httpClient.get(`${this.baseUrl}/admin_api/scholarship/searchgetScholarship?value=` + value + `&pages=` + pages + `&year=` + year + `&collegeId=` + collegeId + `&courseId=` + courseId);
    } catch (error) {
      this.handleError("searchgetScholarship : " + JSON.stringify(error));
    }
  }

  exportScholarshipData(year, collegeId, courseId, yearFilter) {
    try {
      return this.httpClient.get(`${this.baseUrl}/admin_api/scholarship/exportScholarshipData?year=` + year + `&collegeId=` + collegeId + `&courseId=` + courseId + `&yearFilter=` + yearFilter);
    } catch (error) {
      this.handleError("exportScholarshipData : " + JSON.stringify(error));
    }
  }

  getStudentInstallments(userId, year = 1) {
    try {
      return this.httpClient.get(`${this.baseUrl}/admin_api/scholarship/getInstallments?userId=${userId}&year=${year}`);
    } catch (error) {
      this.handleError("getStudentInstallments : " + JSON.stringify(error));
    }
  }

  saveStudentInstallments(userId, installments, year = 1) {
    try {
      return this.httpClient.post(`${this.baseUrl}/admin_api/scholarship/saveInstallments`, { userId, installments, year });
    } catch (error) {
      this.handleError("saveStudentInstallments : " + JSON.stringify(error));
    }
  }

  searchgetapplicationByStatus(year,event,pages, collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/report/searchgetapplicationByStatus?year=`+year +`&event=`+event + `&pages=`+pages+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("searchgetapplicationByStatus : "+JSON.stringify(error));
    }
  }
  Searchactivitytracker(event,pages,collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/report/Searchactivitytracker?value=`+event+`&pages=`+pages+`&collegeId=`+collegeId);
    }catch(error) {
      this.handleError("Searchactivitytracker : "+JSON.stringify(error));
    }
  }
  Search6interested_data(event,pages){
    try{
      return this.httpClient.get(`${this.baseUrl}/Searchinterested_data?value=`+event+`&pages=`+pages);
    }catch(error) {
      this.handleError("interested_data : "+JSON.stringify(error));
    }
  }
  Searchcampaign_data(event,pages){
    try{
      return this.httpClient.get(`${this.baseUrl}/Searchcampaign_data?value=`+event+`&pages=`+pages);
    }catch(error) {
      this.handleError("campaign_data : "+JSON.stringify(error));
    }
  }
  SearchgetApplicationAcceptance(year,event,pages, collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/report/SearchgetApplicationAcceptance?year=`+year +`&event=`+event + `&pages=`+pages+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("searchgetapplicationByStatus : "+JSON.stringify(error));
    }
  }

  SearchgetStudenttracking(year,pages,event,collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Dashboard/SearchgetStudenttracking?year=`+year +`&event=`+event + `&pages=`+pages+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("searchgetapplicationByStatus : "+JSON.stringify(error));
    }
  }
  Search2getStudenttracking(year,pages,event,collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/Dashboard/Search2getStudenttracking?year=`+year +`&event=`+event + `&pages=`+pages+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("searchgetapplicationByStatus : "+JSON.stringify(error));
    }
  }

  deleteBrochureFiles(courseId, collegeId) {
    try {
      return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/deleteBrochureFiles`, { "courseId": courseId, "collegeId": collegeId })
        .pipe(map(res => {
          return res;
        }))
    } catch (error) {
      this.handleError("deleteBrochureFiles : " + error);
    }
  }

  downloadBrochureFiles(fileName, courseId, collegeId): Observable<Blob> {
    try {
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/download?fileName=` + fileName + `&courseId=` + courseId + `&collegeId=` + collegeId, { headers: headers, responseType: 'blob' }).pipe(map(
        (res) => {
          return new Blob([res], { type: 'application/pdf' });
        }));
    } catch (error) {
      this.handleError("unable to get Files : " + JSON.stringify(error));
    }
  }

  getAllCoursesData(value) {
    try {
      return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getAllCoursesData?collegeId=` + value);
    } catch (error) {
      this.handleError("getAllCoursesData : " + JSON.stringify(error));
    }
  }

  addSemester(semesterData){
    try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/addSemester`,semesterData);
    }catch(error){
      this.handleError("addSemester(error) : "+JSON.stringify(error));
    }
  }

  getAllSemesters(page,course_specialization_id,collegeId){
    try{
      return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getAllSemesters?page=`+page+`&course_specialization_id=`+course_specialization_id+`&collegeId=`+collegeId);
    }catch(error){
      this.handleError("getAllSemesters(error) : "+JSON.stringify(error));
    }
  }

  addSubject(subjectData){
    try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/addSubject`,subjectData);
    }catch(error){
      this.handleError("addSubject(error) : "+JSON.stringify(error));
    }
  }

  addSemesterAndSubject(semesterData,subjectData,courseId,collegeId){
    try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/addSemesterAndSubject`,{"semesterData":semesterData,"subjectData":subjectData,"courseId":courseId,"collegeId":collegeId});
    }catch(error){
      this.handleError("addSemesterAndSubject(error) : "+JSON.stringify(error));
    }
  }

  addCourseDetails(item){
    try{
      return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/addCourseDetails`,item);
    }catch(error){
      this.handleError("addCourseDetailsStatus : "+JSON.stringify(error));
    }
}
 getCourseDetails(collegeId: number){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getCourseDetails?collegeId=${collegeId}`)
  }catch(error){
    this.handleError("getCourseDetailsStatus : "+JSON.stringify(error));
  }
 }

 getCourseDetailsById(courseId,collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getCourseDetailsById?courseId=`+courseId+'&collegeId='+collegeId)
  }catch(error){
    this.handleError("getCourseDetailsById : "+JSON.stringify(error));
  }
 }

 addCollege(items){
  try{
    return this.httpClient.post(`${this.baseUrl}/addCollege`,items)
  }catch(error){
    this.handleError("addCollege : "+JSON.stringify(error));
 }
}

getColleges(){
  try{
    return this.httpClient.get(`${this.baseUrl}/getColleges`)
}catch(err){
  this.handleError("getColleges : "+JSON.stringify(err));
}
}

getCollegeRegi(){
  try{
    return this.httpClient.get(`${this.baseUrl}/getCollegeRegi`)
  }catch(err){
    this.handleError("getCollegeRegi : "+JSON.stringify(err));
  }
}

deleteColleges(collegeId){
  try{
   return this.httpClient.delete(`${this.baseUrl}/deleteColleges?id=${collegeId}`)
  }catch(err){
    this.handleError("delete : "+JSON.stringify(err));
  }
}

getUserDetails(userId){
  try{
    return this.httpClient.get(`${this.baseUrl}/getUserDetails?userId=${userId}`)
}catch(err){
  this.handleError("getUserDetails : "+JSON.stringify(err));
}
}

getAllCourses(collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getAllCourseData?collegeId=`+collegeId);
  }catch(error) {
    this.handleError("getAllCourseData : "+JSON.stringify(error));
  }
}

getUserCollegeDetails(collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/getUserCollegeDetails?collegeId=${collegeId}`)
}catch(err){
  this.handleError("getUserCollegeDetails : "+JSON.stringify(err));
}
}

saveInTake(data,courseId,collegeId){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/addInTakeForCourse`,{data,courseId,collegeId});
  }catch(error) {
    this.handleError("addInTakeForCourse : "+JSON.stringify(error));
  }
}
getSpecificInTake(courseId,collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getSpecificInTake?courseId=${courseId}&collegeId=${collegeId}`);
  }catch(error) {
    this.handleError("getSpecificInTake : "+JSON.stringify(error));
  }
}
saveCollege(college: FormData){
  try{
    return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/saveCollege`,college);
  }catch(error) {
    this.handleError("saveCollege : "+JSON.stringify(error));
  }
}

getCourse(){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getCourse`);
  }catch(error){
    this.handleError("getCourse : "+JSON.stringify(error));
  }
}

allocateCourse(data,collegeId){
try{
  return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/allocateCourse`,{data,collegeId});
}catch(error){
  this.handleError("allocateCourse : "+JSON.stringify(error));
}
}

getCollegeCourses(collegeId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getCollegeCourses?collegeId=${collegeId}`);
  }catch(error){
    this.handleError("getCollegeCourses : "+JSON.stringify(error));
  }
}
deleteAllocatedCourse(collegeCourseId){
  try{
  return this.httpClient.delete(`${this.baseUrl}/admin_api/institute_management/deleteAllocatedCourse?collegeCourseId=${collegeCourseId}`);
  }catch(error){
    this.handleError("deleteAllocatedCourse : "+JSON.stringify(error));
  }
}

particularCourseDetails(courseId){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/particularCourseDetails?courseId=${courseId}`);
  }catch(error){
    console.log("particularCourseDetails : "+JSON.stringify(error));
  }
}

saveCollegeCourseDetails(data,courseId){
  try{
   return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/saveCollegeCourseDetails`,{data,courseId})
  }catch(error){
    console.log("saveCourseDetails : "+JSON.stringify(error));
  }
}

addAdmin(data:any){
  try{
   return this.httpClient.post(`${this.baseUrl}/admin_api/institute_management/addAdmin`,{data})
  }catch(error){
    console.log("addAdmin : "+JSON.stringify(error));
  }
}

preAddAdmin(data:any){
  try{
   return this.httpClient.post(`${this.preBaseUrl}/admin_api/institute_management/addAdmin`,{data})
  }catch(error){
    console.log("addAdmin : "+JSON.stringify(error));
  }
}

getCollegesAdmin(collegeId: number,page:number){
  try{
     return this.httpClient.get(`${this.baseUrl}/admin_api/institute_management/getCollegesAdmin?collegeId=${collegeId}&page=${page}`);
  }catch(error){
    console.log("getCollegesAdmin : "+JSON.stringify(error));
  }
}
change_user_status(status:string,userId: number){
  try{
   return this.httpClient.put(`${this.baseUrl}/admin_api/institute_management/change_user_status`,{status,userId})
  }catch(error){
    console.log("change_user_status : "+JSON.stringify(error));
  }
}

getApplicationNew(tab_type,academic_year,pages,collegeId){
  try{
      return this.httpClient.get(`${this.preBaseUrl}/admin_api/Eligibility/CheckEligibility?tab=`+tab_type+`&year=`+academic_year+`&pages=`+pages+`&collegeId=`+collegeId);
  }catch(error) {
      this.handleError("getApplicationinEligibility : "+JSON.stringify(error));
  }
}

downloadReceipts(file_name, user_id):Observable<Blob>{
  try{
  let headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.httpClient.get(`${this.preBaseUrl}/downloadReceipts?file_name=`+file_name+`&user_id=`+user_id, { headers: headers, responseType: 'blob'}).pipe(map(
      (res) => {
          return new Blob([res], { type: 'application/pdf' });
      }));
  }catch(error) {
    this.handleError("unable to get Files : "+JSON.stringify(error));
  }
}

// save the 
createRegisteration(formData:FormData){
  try{
    return this.httpClient.post(`${this.baseUrl}/createRegister`,formData)
  }catch(err){
    this.handleError("createRegister : "+JSON.stringify(err));
  }
}

Step2registeration(formData:FormData){
  try{
    return this.httpClient.post(`${this.baseUrl}/Step2registeration`,formData)
  }catch(err){
    this.handleError("Step2registeration : "+JSON.stringify(err));
  }
}

Step3registeration(formData:FormData){          
  try{
    return this.httpClient.post(`${this.baseUrl}/Step3registeration`,formData)
  }catch(err){
    this.handleError("Step3registeration : "+JSON.stringify(err));
  }
}

Step4registeration(formData:FormData){          
  try{
    return this.httpClient.post(`${this.baseUrl}/Step4registeration`,formData)
  }catch(err){
    this.handleError("Step4registeration : "+JSON.stringify(err));
  }
}

saveregisteration(formData:FormData){          
  try{
    return this.httpClient.post(`${this.baseUrl}/saveregisteration`,formData)
  }catch(err){
    this.handleError("saveregisteration : "+JSON.stringify(err));
  }
}
checkRegisteration(email:string){
  try{
    return this.httpClient.get(`${this.baseUrl}/checkRegisteration?email=${email}`)
  }catch(err){
    this.handleError("checkRegisteration : "+JSON.stringify(err));
  }
}

getScholarshipRegisterationData(pages){
  try{
    return this.httpClient.get(`${this.baseUrl}/admin_api/scholarship/getScholarshipRegisterationData?pages=`+pages);
  }catch(error) {
      this.handleError("getScholarshipRegisterationData : "+JSON.stringify(error));
  }
}

deleteRegisterationData(id){
  try{
   return this.httpClient.delete(`${this.baseUrl}/admin_api/scholarship/deleteRegisterationData?id=`+id);
  }catch(err){
    this.handleError("deleteRegisterationData : "+JSON.stringify(err))
  }
}
}
